import { APP_NAMES } from '@/utils/constants';

const skandiaLandlordIdArr = [169290, 169296, 169297];

export default {
  // isMobile: state => state.screenSize === 'MOBILE',
  // isSmallDesktop: state => state.screenSize === 'DESKTOP_SMALL',
  // isDesktop: state => state.screenSize === 'DESKTOP',
  tooltips(state) {
    if (state.account?.managerId) {
      return [];
    }
    return state.tooltips;
  },
  ahAccess(state) {
    return state.account?.ahAccess || false;
  },
  baAccess(state) {
    return state.account?.baAccess || false;
  },
  ovPrivateAccess(state) {
    return state.account?.ovPrivateAccess || false;
  },
  ovCompanyAccess(state) {
    return state.account?.ovCompanyAccess || false;
  },
  landlordAhAccess: state => state.account?.landlordAhAccess || false,
  landlordBaAccess: state => state.account?.landlordBaAccess || false,
  landlordOvPrivateAccess: state =>
    state.account?.landlordOvPrivateAccess || false,
  landlordOvCompanyAccess: state =>
    state.account?.landlordOvCompanyAccess || false,
  brf: state => state.account?.brf || false,
  activeMenu: state => {
    if (state.activeApp === APP_NAMES.ANDRAHAND) {
      return state.ahMenu;
    }

    if (state.activeApp === APP_NAMES.OVERLATELSER_PRIVATE) {
      return state.ovPrivateMenu;
    }
    if (state.activeApp === APP_NAMES.OVERLATELSER_COMPANY) {
      return state.ovCompanyMenu;
    }
    return state.baMenu;
  },
  isSkandia(state) {
    const skandiaLandlordIds = skandiaLandlordIdArr;

    if (skandiaLandlordIds.includes(state.account.landlordId)) {
      return true;
    }
    return false;
  },
  activeOvApplicationType(state) {
    return state.activeApp === APP_NAMES.OVERLATELSER_COMPANY
      ? 'ov-company'
      : 'ov-private';
  }
};
